import instance from '../axios-instance';

export type AppointmentData = {
  service: string;
  serviceProvider: string;
  duration: string;
  date: string;
  time_from: string;
  price: string;
  search: string;
  name: string;
  email: string;
  Id: string;
};

export const AddAppointment = async (
  data: AppointmentData,
  clientSlug?: string
) => {
  // The appointments endpoint should never have client slug in the URL
  // Client information is passed in the request body, not the URL
  return (await instance.post('/appointments', data)).data;
};

export const reschedule = async (
  id: string,
  data: any,
  clientSlug?: string
) => {
  // The reschedule endpoint should never have client slug in the URL
  // Client information is passed in the request body, not the URL
  const url = `/appointments/${id}/reschedule?_method=PUT`;
  return (await instance.post(url, data)).data;
};

export const AddMeetingPollAppointment = async (data: AppointmentData, tenantSlug: string) => {
  return (await instance.post(`/${tenantSlug}/event/vote`, data)).data;

};

export const cancelMeeting = async (
  id: string,
  clientSlug: string | undefined,
  data: any
) => {
  // The cancel endpoint should never have client slug in the URL
  // Client information is passed in the request body, not the URL
  const url = `/appointments/${id}/cancel?_method=PUT`;
  return (await instance.post(url, data)).data;
};

export const getHangoutLink = async (
  appointmentNr: string,
  eventSlug: string,
  clientSlug?: string
) => {
  // New URL structure: /shared_links_appointment/{appointment_nr}/{event_slug}/{client_slug?}
  const url = clientSlug
    ? `/shared_links_appointment/${appointmentNr}/${eventSlug}/${clientSlug}`
    : `/shared_links_appointment/${appointmentNr}/${eventSlug}`;
  return (await instance.get(url)).data;
};
